
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitoajantaellora() {



    const cardData =
    {
        keyword: 'Mumbai to ajanta ellora tour package',
        heading: 'Skyline Cabs: Mumbai to ajanta ellora tour package',
        headingDescription: 'Skyline Cabs offers a comfortable and reliable Mumbai to Ajanta Ellora Tour Package, perfect for history enthusiasts and spiritual travelers. Our well-maintained vehicles and professional drivers ensure a smooth and enjoyable journey to these UNESCO World Heritage Sites.​',

        top: 'Top Places to Visit in ajanta ellora with Skyline Cabs',

"topPlaces": [
    {
        "title": "Ajanta Caves",
        "description": "A UNESCO World Heritage site, the Ajanta Caves are a group of 30 rock-cut Buddhist monasteries and temples, featuring exquisite murals and sculptures that date back to the 2nd century BCE. The caves are renowned for their intricate paintings and carvings, which depict the life of the Buddha."
    },
    {
        "title": "Ellora Caves",
        "description": "Another UNESCO World Heritage site, the Ellora Caves are a complex of 34 monasteries and temples carved into cliffs, dating back between the 5th and 10th centuries. The caves showcase a fusion of Hindu, Buddhist, and Jain rock-cut architecture, with awe-inspiring sculptures and intricate carvings."
    },
    {
        "title": "Kailasa Temple (Ellora)",
        "description": "The Kailasa Temple is an extraordinary rock-cut monolithic temple located in Ellora, dedicated to Lord Shiva. It is one of the largest single monolithic rock excavation in the world, known for its architectural grandeur and intricate carvings."
    },
    {
        "title": "Buddha's Meditation Cave (Ajanta)",
        "description": "This cave at Ajanta is known for its serene and peaceful environment, where monks meditated. It features stunning sculptures and frescoes of Buddha in various postures, making it a significant site for visitors interested in Buddhist history and culture."
    },
    {
        "title": "Cave 16 (Ellora)",
        "description": "Cave 16 at Ellora is home to the magnificent Kailasa Temple. This cave stands out for its large size and architectural complexity, and the carvings within depict stories from Hindu mythology and life of Lord Shiva."
    },
    {
        "title": "Ajanta Waterfall",
        "description": "Located near the Ajanta Caves, this waterfall offers a picturesque view and is an ideal spot for nature lovers. It is especially beautiful during the monsoon season and provides a serene backdrop for visitors."
    },
    {
        "title": "Saptashrungi",
        "description": "Located near Nashik, about 80 km from Ajanta and Ellora, Saptashrungi is a sacred pilgrimage site, home to the Saptashrungi Devi temple. It is a popular trekking destination, offering a panoramic view of the surrounding mountains and forests."
    },
    {
        "title": "Grishneshwar Temple (Ellora)",
        "description": "Grishneshwar Temple, one of the 12 Jyotirlingas, is located near Ellora. The temple is dedicated to Lord Shiva and is an important religious site for pilgrims. It is known for its architecture and spiritual significance."
    },
    {
        "title": "Bibi Ka Maqbara (Aurangabad)",
        "description": "Located in Aurangabad, around 30 km from Ajanta and Ellora, Bibi Ka Maqbara is an exquisite mausoleum built in the 17th century. Often referred to as the 'Taj of the Deccan,' it is a beautiful architectural gem that attracts tourists for its charm and historical significance."
    },
    {
        "title": "Aurangabad Caves",
        "description": "Situated in the hills near Aurangabad, the Aurangabad Caves are a group of 12 Buddhist rock-cut caves. These caves feature beautiful sculptures and carvings, making them an interesting place for visitors to explore after visiting Ajanta and Ellora."
    }
],

"services": [
    {
      "name": "Mumbai to Ajanta Ellora Tour",
      "description": "Skyline Cabs offers curated cab tours from Mumbai to Ajanta and Ellora caves. Explore these historic UNESCO sites with comfort and ease."
    },
    {
      "name": "Ajanta Ellora Tour from Mumbai",
      "description": "Plan your cultural getaway with Skyline Cabs. Our Mumbai to Ajanta Ellora tour service provides a convenient and informative travel experience."
    },
    {
      "name": "Ajanta Ellora Taxi Service",
      "description": "Skyline Cabs provides reliable taxi services to Ajanta and Ellora from Mumbai. Travel in comfort with our well-maintained cabs and expert drivers."
    },
    {
      "name": "Mumbai to Ajanta Ellora Package",
      "description": "Choose from flexible Mumbai to Ajanta Ellora tour packages by Skyline Cabs. Enjoy guided travel with cab service tailored to your itinerary."
    },
    {
      "name": "Ajanta Ellora Cab Booking",
      "description": "Book your cab from Mumbai to Ajanta Ellora easily with Skyline Cabs. We offer safe, comfortable rides and simple booking options."
    },
    {
      "name": "Mumbai to Ajanta Ellora Darshan",
      "description": "Experience spiritual and historical wonders with Skyline Cabs’ Mumbai to Ajanta Ellora darshan service. A smooth and enriching ride awaits."
    }
  ],
  "tableData": [
    ["Mumbai to Ajanta Ellora Tour", "Ajanta Ellora Tour from Mumbai"],
    ["Ajanta Ellora Taxi Service", "Mumbai to Ajanta Ellora Package"],
    ["Ajanta Ellora Cab Booking", "Mumbai to Ajanta Ellora Darshan"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai to Ajanta Ellora Tour Package",
      "WhyChoosedescription": "Explore the world-renowned Ajanta and Ellora Caves with our comfortable and well-planned tour package from Mumbai. Ideal for history lovers, culture seekers, and family travelers."
    },
    {
      "WhyChooseheading": "Comfortable Travel in AC Cabs",
      "WhyChoosedescription": "Enjoy a relaxed journey from Mumbai to Aurangabad in our comfortable air-conditioned cabs, designed for long-distance travel with ample legroom and smooth suspension."
    },
    {
      "WhyChooseheading": "Customizable Tour Itinerary",
      "WhyChoosedescription": "We offer flexible and customizable tour plans that can include visits to Ajanta Caves, Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and more, based on your interests and schedule."
    },
    {
      "WhyChooseheading": "Affordable Tour Packages with No Hidden Costs",
      "WhyChoosedescription": "Our tour packages are competitively priced with clear and transparent billing. Get great value without any surprise charges."
    },
    {
      "WhyChooseheading": "Experienced Drivers and Local Travel Assistance",
      "WhyChoosedescription": "Our courteous and knowledgeable drivers are familiar with the entire route and local attractions, providing a safe and informative travel experience."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All our tour vehicles are thoroughly cleaned and sanitized before every trip, ensuring hygiene and comfort for all passengers."
    },
    {
      "WhyChooseheading": "Ideal for Solo, Family, or Group Tours",
      "WhyChoosedescription": "Whether you're traveling alone, with family, or as a group, we have vehicle and tour options suited for all kinds of travelers."
    },
    {
      "WhyChooseheading": "24/7 Customer Support and Easy Booking",
      "WhyChoosedescription": "Book your Ajanta Ellora tour package easily online or over the phone, with round-the-clock customer support to assist you at every step of the way."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Ajanta Ellora tour package with Skyline Cabs?',
            answer:
                'Booking your Ajanta Ellora tour with Skyline Cabs is easy. Visit our website, mobile app, or call our customer support. Select your pickup point in Mumbai, preferred travel dates, and vehicle type to confirm the tour package.',
        },
        {
            id: 2,
            question: 'What is included in the Ajanta Ellora tour package?',
            answer:
                'Our tour package includes a round-trip cab from Mumbai, sightseeing at Ajanta and Ellora caves, driver allowance, fuel, tolls, and taxes. Custom itineraries can include nearby spots like Daulatabad Fort, Bibi Ka Maqbara, and Grishneshwar Temple.',
        },
        {
            id: 3,
            question: 'What is the distance and travel time from Mumbai to Ajanta and Ellora?',
            answer:
                'The total distance from Mumbai to Ellora is about 340 km, and Ajanta is around 100 km further. Travel time from Mumbai to Aurangabad (base city) is about 7–8 hours. The tour can be done in 2 or 3 days depending on your pace.',
        },
        {
            id: 4,
            question: 'What vehicle options are available for this tour?',
            answer:
                'Skyline Cabs offers a variety of vehicles for the tour including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For families or groups, Tempo Travellers and mini-buses are also available.',
        },
        {
            id: 5,
            question: 'Are the entry tickets to Ajanta and Ellora included?',
            answer:
                'Entry tickets to the Ajanta and Ellora caves are not included in the cab fare. You can purchase them at the respective entrances or online through the official ASI website.',
        },
        {
            id: 6,
            question: 'Can I customize the itinerary for the Ajanta Ellora tour?',
            answer:
                'Yes, Skyline Cabs offers customizable itineraries. You can add nearby attractions or extend your stay in Aurangabad based on your interests and schedule.',
        },
        {
            id: 7,
            question: 'Are overnight stays arranged as part of the tour?',
            answer:
                'Accommodation is not included in the base cab package, but we can help you arrange hotel bookings in Aurangabad upon request. You can choose from budget to premium options.',
        },
        {
            id: 8,
            question: 'What are the payment options available?',
            answer:
                'You can pay via UPI, credit/debit cards, net banking, or cash. All online transactions are processed securely through verified payment gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my tour package?',
            answer:
                'Yes, we offer flexible cancellation and rescheduling policies. You can modify or cancel your tour easily via our app, website, or customer support team.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Ajanta Ellora tour?',
            answer:
                'Skyline Cabs ensures a safe, comfortable, and enriching travel experience. With experienced drivers, clean vehicles, and transparent pricing, we make your historical journey memorable and stress-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rahul Mahale",
            rating: 5,
            review: "Our Ajanta Ellora trip with Skyline Cabs was amazing. The cab was on time, the driver was very knowledgeable about the sites, and everything went smoothly. Highly recommended!"
        },
        {
            name: "Mrs. Kavita Joshi",
            rating: 4,
            review: "Comfortable ride from Mumbai to Ajanta and Ellora. We stopped at Bibi Ka Maqbara and Daulatabad too. Would have loved if the package included hotel stay, but overall, a great experience!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ajanta Ellora Tour Package",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-ajanta-ellora-tour.jpg",
  "description": "Book a Mumbai to Ajanta Ellora Tour Package with Skyline Cabs and explore UNESCO World Heritage Sites in comfort. Enjoy AC sedans, SUVs, and luxury cab options with professional drivers and customizable itineraries.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8642"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-ajanta-ellora-tour-package"
  }
};



      
      
      

    return (
        <div>
<Helmet>
  <title>Mumbai to Ajanta Ellora Tour Package | Cab Booking with Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book a Mumbai to Ajanta Ellora Tour Package with Skyline Cabs and explore UNESCO World Heritage Sites in comfort. Enjoy AC sedans, SUVs, and luxury cab options with professional drivers and customizable itineraries." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Ajanta Ellora Tour Package, Cab from Mumbai to Ajanta Caves, Mumbai to Ellora Caves Taxi, UNESCO Sites Cab Tour from Mumbai, One Day Ajanta Ellora Trip, Skyline Cabs Ajanta Ellora Tour, Mumbai to Aurangabad Sightseeing Cab, AC Taxi for Ajanta Ellora, SUV and Sedan Tour Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/105.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoajantaellora;